/**
 * Famous Fur-ends — Carousel + Lightbox
 * MadPrints | shopmadprints.com
 */

window.FamousFurEnds = (function () {

  'use strict';

  function buildEmbedUrl(url, type) {
    if (!url) return null;
    if (type === 'youtube') {
      var match = url.match(/(?:youtube\.com\/(?:watch\?v=|shorts\/)|youtu\.be\/)([A-Za-z0-9_-]{11})/);
      return match ? 'https://www.youtube.com/embed/' + match[1] + '?autoplay=1&rel=0' : null;
    }
    if (type === 'vimeo') {
      var match = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
      return match ? 'https://player.vimeo.com/video/' + match[1] + '?autoplay=1' : null;
    }
    return null;
  }

  function init(sectionSelector, modalSelector) {
    var section = document.querySelector(sectionSelector);
    var modal   = document.querySelector(modalSelector);

    if (!section || !modal) return;

    var track   = section.querySelector('[data-fur-ends-track]');
    var prevBtn = section.querySelector('[data-fur-ends-prev]');
    var nextBtn = section.querySelector('[data-fur-ends-next]');
    
    // Modal Selectors
    var modalContent = modal.querySelector('[data-fur-ends-modal-content]');
    var closeBtns  = modal.querySelectorAll('[data-fur-ends-close]');
    var mPrevBtn   = modal.querySelector('[data-fur-ends-modal-prev]');
    var mNextBtn   = modal.querySelector('[data-fur-ends-modal-next]');

    var cards = section.querySelectorAll('.fur-ends-card');
    var videoData = []; // Store array of objects
    var currentIndex = 0;

    /* ── Carousel Logic & Hover Play ── */
    cards.forEach(function (card, index) {
      var src = card.getAttribute('data-video-src');
      var type = card.getAttribute('data-video-type');
      videoData.push({ src: src, type: type });

      var inlineVideo = card.querySelector('video');
      var playPromise;

      // Play MP4 on hover
      card.addEventListener('mouseenter', function () {
        if (inlineVideo) {
          playPromise = inlineVideo.play();
          if (playPromise !== undefined) {
            playPromise.catch(function (error) {
              console.log("Autoplay prevented:", error);
            });
          }
        }
      });

      // Pause MP4 on mouseleave
      card.addEventListener('mouseleave', function () {
        if (inlineVideo && playPromise !== undefined) {
          playPromise.then(function () {
            inlineVideo.pause();
          }).catch(function () {});
        }
      });

      // Click to open modal
      card.addEventListener('click', function () {
        if (!src) return; // Ignore cards without video URLs
        currentIndex = index;
        openModal(currentIndex);
      });
    });

    /* ── Track Scrolling Arrows ── */
    function getScrollAmount() {
      var card = track.querySelector('.fur-ends-card');
      return card ? card.offsetWidth + 16 : 300; 
    }

    function updateArrows() {
      if (!prevBtn || !nextBtn) return;
      prevBtn.classList.toggle('is-disabled', track.scrollLeft <= 4);
      nextBtn.classList.toggle('is-disabled', track.scrollLeft >= track.scrollWidth - track.clientWidth - 4);
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
      });
    }

    if (track) {
      track.addEventListener('scroll', updateArrows, { passive: true });
      updateArrows(); 
    }

    /* ── Modal Functions ── */
    function openModal(index) {
      var data = videoData[index];
      if (!data || !data.src) return;

      modalContent.innerHTML = ''; // Clear previous content

      if (data.type === 'mp4') {
        modalContent.innerHTML = '<video controls autoplay playsinline src="' + data.src + '" style="width: 100%; height: 100%; object-fit: cover;"></video>';
        var v = modalContent.querySelector('video');
        v.muted = false; 
        v.play().catch(function(e) { console.log(e); });
      } else {
        var embedUrl = buildEmbedUrl(data.src, data.type);
        if (embedUrl) {
          modalContent.innerHTML = '<iframe src="' + embedUrl + '" allow="autoplay; fullscreen" allowfullscreen style="width:100%; height:100%; border:none;"></iframe>';
        } else {
          window.open(data.src, '_blank'); // fallback
          return;
        }
      }

      modal.hidden = false;
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      modal.hidden = true;
      document.body.style.overflow = '';
      modalContent.innerHTML = ''; // Clear src to stop buffering/playback
    }

    function showPrev() {
      do {
        currentIndex = (currentIndex > 0) ? currentIndex - 1 : videoData.length - 1;
      } while (!videoData[currentIndex].src && currentIndex !== 0);
      openModal(currentIndex);
    }

    function showNext() {
      var startIndex = currentIndex;
      do {
        currentIndex = (currentIndex < videoData.length - 1) ? currentIndex + 1 : 0;
      } while (!videoData[currentIndex].src && currentIndex !== startIndex);
      openModal(currentIndex);
    }

    // Modal Event Listeners
    closeBtns.forEach(function (btn) {
      btn.addEventListener('click', closeModal);
    });

    if (mPrevBtn) {
      mPrevBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        showPrev();
      });
    }

    if (mNextBtn) {
      mNextBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        showNext();
      });
    }

    // Keyboard navigation
    document.addEventListener('keydown', function (e) {
      if (modal.hidden) return;
      if (e.key === 'Escape') closeModal();
      if (e.key === 'ArrowLeft') showPrev();
      if (e.key === 'ArrowRight') showNext();
    });
  }

  return { init: init };

}());